




















import { Vue, Component } from 'vue-property-decorator'
import { SupplyChart } from '@/types/newPersion'
import { supplyChart } from '@/api/newPersion'
import { CommonMudule } from '@/store/modules/common'
import { comdify2 } from '@/utils/validate'
import { PonitXYInside } from '@/types/common/g2Charts'
import InsideBarChart from '@/components/g2Charts/chartList/insideBarChart'
import TsTable from '@/components/TsTable/TsTable.vue'
import cardWraper from '@/common/cardMap/cardLayout/cardWraper.vue'
@Component({
  components: { InsideBarChart, TsTable, cardWraper },
})
export default class extends Vue {
  form = {};
  comdify2 = comdify2;
  chartOptions = {
    position: [],
    legendPosition: 'top',
    titleNextContent: '岁',
    stackContent: '',
    valueNextContent: '(元/月)',
    // annotationContent: '单位:元',
  };

  chartData: PonitXYInside[] = [];

  mounted () {
    this.getData()
  }

  private async getData () {
    const res = await supplyChart({ customerId: CommonMudule.customerId })
    if (res?.data) {
      const supplyEnum = {
        age: '',
        insuranceAmount: '社保养老金额', // 社保养老金额
        rentAmount: '房租可提供金额', // 房租可提供金额
        annuityAmount: '年金可提供金额', // 年金可提供金额
        otherAmount: '其他收入可提供金额', // 其他收入可提供金额
      }
      const _chartData: PonitXYInside[] = []
      const { pensionSupplies, discountAmount, totalAmount, averageAmount } = res.data
      this.form = {
        discountAmount,
        totalAmount,
        averageAmount
      }
      pensionSupplies.forEach((item: SupplyChart) => {
        for (const k in item) {
          if (k !== 'age' && supplyEnum[k]) {
            _chartData.push({
              x: item.age + '',
              y: item[k],
              type: supplyEnum[k],
            })
          }
        }
      })
      this.chartData = _chartData
    }
  }
}
